import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { GetDecisionManagersParams } from "apis/data-contracts";

const useGetDecisionManagersQuery = (query: GetDecisionManagersParams) => {
  return useSuspenseQuery({
    queryKey: api.user.getDecisionManagersKey(query),
    queryFn: () => api.user.getDecisionManagers(query),
    select: (res) => res.data.result,
  });
};

export default useGetDecisionManagersQuery;
